//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngCheckbox', srsngCheckbox);

    function srsngCheckbox() {

        return {
            restrict: 'E',
            scope: {
                checked: '=',
                action: '&',
                inactive: '=',
                viewonly: '='
            },
            templateUrl: 'container/ui/app/widgets/checkbox/checkbox.html',
            controller: controller
        };

        function controller($scope, $element, $timeout) {
            $scope.toggle = toggle;

            function toggle(){
                $scope.checked = !$scope.checked;
                
                $timeout(function() {
                    $scope.action();
                });
            }
        }            

    }

})();

